<template>
  <div class="h-full">
    <div class="m-6 clearfix">
      <vs-button class="bg-primary-gradient w-full" icon-pack="feather" icon="icon-shopping-cart" :to="{name: 'shop'}">
        {{ $t('pages.cases.caseView.buttons.shop') }}
      </vs-button>
    </div>

    <component :is="scrollbarTag" class="case-filter-scroll-area" :settings="settings" :key="$vs.rtl">
      <div class="p-2 flex flex-col">
        <filter-status-item :status-text="$t('lists.caseStatus.new')" status-case="new" icon="PlusIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.revision')" status-case="revision" icon="AlertOctagonIcon" v-if="$store.state.Profile.isSupervisor()"/>
        <filter-status-item :status-text="$t('lists.caseStatus.checkingout')" status-case="checkingout" icon="SearchIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.execute')" status-case="execute" icon="PlayIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.approve')" status-case="approve" icon="CheckIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.finishing')" status-case="finishing" icon="FastForwardIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.print')" status-case="print" icon="PrinterIcon"/>
        <filter-status-item :status-text="$t('lists.caseStatus.finished')" status-case="finished" icon="CheckCircleIcon"/>
      </div>
    </component>
  </div>
</template>

<script>
//TODO usar bds-scroll-bar...
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FilterStatusItem from "@/views/cases/Components/FilterStatusItem";

export default {
  name: 'case-filter',
  components: {
    VuePerfectScrollbar,
    FilterStatusItem
  },
  props: {

  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {

  },
  mounted() {

  }
}

</script>

